import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 28em;
  overflow: hidden;
  margin-top: 8px;

  img.file {
    height: 23em;
    width: auto;
    object-fit: cover;
    margin: 15px;
  }

  video {
    width: inherit;
    margin: 15px;
  }
`;
